{
  "search": "Suchen",
  "searchWithin": "Suchen in"
}
